export function useResolvePathFromSlug(): string {
    const route = useRoute();
    const { slug } = route.params;

    if (!slug) {
        return 'index';
    }

    const slugHasMultipleParts = Array.isArray(slug) && slug[1] !== undefined;
    const path = Array.isArray(slug) && slugHasMultipleParts ? slug.join('/') : slug[0];
    return path;
}
